/* AukCliff size help window: the size chart and "What's my size?" in one window.
   A port of data/size_finder/prototype.html (approved 2026-10-18). Plain JS, no dependencies on
   other theme scripts, no network calls at runtime other than the video, its poster and the
   measuring drawing. The garment numbers come from the JSON block that snippets/auk-size-window.liquid
   renders inside the window (generated from build_sizechart.py TABLES by
   data/size_finder/theme_build/build_window_data.py); nothing is typed here. Safe to load twice. */
(function () {
  "use strict";
  var root = document.getElementById("auk-sw");
  if (!root || root.getAttribute("data-auk-sw-ready")) return;      /* no window on this page, or already wired */
  var dataEl = root.querySelector("#auk-sw-data");
  var G;
  try { G = JSON.parse(dataEl.textContent); } catch (e) { return; }
  if (!G || !G.key) return;
  root.setAttribute("data-auk-sw-ready", "1");

  /* ------------------------------------------------------------------ the model ----
     Identical to the prototype's <script id="auk-size-model">, with GARMENTS filled from the
     page's JSON instead of a copy. Exposed as window.AukSize, as the prototype does. */
  var GARMENTS = {};
  GARMENTS[G.key] = { label: G.label, allowance: G.allowance, cut: G.cut,
    sizes: G.sizes, width: G.width, length: G.length, sleeve: G.sleeve };
  /* Target room (garment chest minus body chest), cm. */
  var EASE = {
    tee:    { closer: 3,  regular: 8,  roomier: 13 },
    fleece: { closer: 9,  regular: 14, roomier: 19 }
  };
  var BETWEEN_CM = 2.5;   /* second-best within this of the best = between sizes, go up one */
  /* ANSUR II linear fits (see data/size_finder/audit.md). chest cm from kg, cm, years. */
  var CHEST = {
    m: { b0: 98.1927, w: 0.6025, h: -0.2687, a: 0.1111, rmse: 3.09 },
    f: { b0: 93.4551, w: 0.6985, h: -0.3054, a: 0.1255, rmse: 4.14 }
  };
  var TORSO = {   /* cervicale to crotch, cm */
    m: { b0: 15.3483, h: 0.2633, w: 0.0648 },
    f: { b0: 12.0680, h: 0.2861, w: 0.0396 }
  };
  function clamp(v, lo, hi) { return Math.min(hi, Math.max(lo, v)); }
  /* One decimal, rounded on the exact binary value like Python's round() in build_sizechart.py,
     so 32.5 in shows 82.5 cm here as it does on the live page (Math.round would give 82.6). */
  function r1(v) { return Number(v.toFixed(1)); }
  function estimateChest(sex, kg, cm, age) {
    age = (age == null || isNaN(age)) ? 35 : clamp(age, 16, 100);   /* survey median region when unknown */
    kg = clamp(kg, 30, 250); cm = clamp(cm, 120, 230);
    function one(k) { var c = CHEST[k]; return c.b0 + c.w * kg + c.h * cm + c.a * age; }
    if (sex === "m" || sex === "f") return { chest: one(sex), rmse: CHEST[sex].rmse, basis: "estimate" };
    return { chest: (one("m") + one("f")) / 2, rmse: 4.5, basis: "estimate" };
  }
  function estimateTorso(sex, kg, cm) {
    function one(k) { var t = TORSO[k]; return t.b0 + t.h * cm + t.w * kg; }
    if (sex === "m" || sex === "f") return one(sex);
    return (one("m") + one("f")) / 2;
  }
  /* input: { garment, kg, cm, sex ('m'|'f'|'x'), age?, fit ('closer'|'regular'|'roomier'), chestCm?, usual? } */
  function recommend(input) {
    var g = GARMENTS[input.garment];
    if (!g) throw new Error("unknown garment " + input.garment);
    var fit = EASE[g.allowance][input.fit] != null ? input.fit : "regular";
    var target = EASE[g.allowance][fit];
    var est = (input.chestCm > 0) ? { chest: input.chestCm, rmse: 1.5, basis: "measured" }
                                  : estimateChest(input.sex, input.kg, input.cm, input.age);
    var body = est.chest;
    var rows = g.sizes.map(function (s, i) {
      var gc = g.width[i] * 2 * 2.54;
      return { size: s, index: i, garmentChest: gc, room: gc - body, dist: Math.abs(gc - body - target) };
    });
    var sorted = rows.slice().sort(function (a, b) { return a.dist - b.dist; });
    var best = sorted[0], second = sorted[1];
    var between = second && Math.abs(second.dist - best.dist) <= BETWEEN_CM && Math.abs(second.index - best.index) === 1;
    var pick = best;
    if (between) pick = (second.index > best.index) ? second : best;   /* between sizes: go up one */
    var edge = null;
    if (pick.index === 0 && pick.room > target + 6) edge = "smallest";
    if (pick.index === rows.length - 1 && pick.room < target - 6) edge = "largest";
    var torso = estimateTorso(input.sex, input.kg, input.cm);
    var lengthCm = g.length[pick.index] * 2.54;
    var hemBelowCrotch = lengthCm - torso;   /* hangs from the neck point; positive = hem below crotch level */
    return {
      garment: input.garment, label: g.label, allowance: g.allowance, cut: g.cut, fit: fit, target: target,
      bodyChest: body, chestBasis: est.basis, chestRmse: est.rmse,
      size: pick.size, index: pick.index, room: pick.room, garmentChest: pick.garmentChest,
      between: between ? [rows[Math.min(best.index, second.index)].size, rows[Math.max(best.index, second.index)].size] : null,
      edge: edge, rows: rows,
      measurements: { length_in: g.length[pick.index], width_in: g.width[pick.index], sleeve_in: g.sleeve ? g.sleeve[pick.index] : null,
                      length_cm: r1(lengthCm), width_cm: r1(g.width[pick.index] * 2.54), sleeve_cm: g.sleeve ? r1(g.sleeve[pick.index] * 2.54) : null },
      torso: torso, hemBelowCrotch: hemBelowCrotch,
      usual: input.usual || null
    };
  }
  /* Shopper-facing sentences, word for word from the prototype. */
  function fitWord(room, allowance) {
    var t = EASE[allowance];
    if (room < t.closer - 4) return "tight";
    if (room < (t.closer + t.regular) / 2) return "close";
    if (room <= (t.regular + t.roomier) / 2) return "regular";
    if (room <= t.roomier + 5) return "roomy";
    return "oversized";
  }
  function explain(r) {
    var chest = Math.round(r.bodyChest);
    var room = Math.round(r.room);
    var basis = r.chestBasis === "measured" ? "around your " + chest + " cm chest" : "around a chest of about " + chest + " cm";
    var word = fitWord(r.room, r.allowance);
    var line;
    if (r.edge === "smallest") {
      line = "S is our smallest size. " + basis.charAt(0).toUpperCase() + basis.slice(1) + " it will be " + word + ", with about " + room + " cm of room.";
    } else if (r.edge === "largest") {
      line = r.size + " is our largest size. " + basis.charAt(0).toUpperCase() + basis.slice(1) + " it will be " + word + (room < 0 ? ", about " + Math.abs(room) + " cm short of a comfortable fit." : ".");
    } else if (r.between) {
      line = "You are between " + r.between[0] + " and " + r.between[1] + ". Between sizes, go up one: " + r.size + " gives about " + room + " cm of room " + basis + ", a " + word + " fit.";
    } else {
      line = r.size + " gives about " + room + " cm of room " + basis + ", a " + word + " fit.";
    }
    if (r.allowance === "fleece") line += " This fleece is a fitted cut and we have allowed for a layer underneath.";
    else if (r.cut === "relaxed") line += " This tee is a heavier, relaxed cut.";
    return line;
  }
  function lengthNote(r) {
    var d = r.hemBelowCrotch;
    var where = d < -4 ? "a little above the hip" : d <= 6 ? "at the hip" : d <= 12 ? "just below the hip" : "well below the hip";
    return "Length " + r.measurements.length_cm + " cm, which on your frame should sit " + where + ".";
  }
  function usualNote(r) {
    if (!r.usual) return "";
    var g = GARMENTS[r.garment];
    var ui = g.sizes.indexOf(r.usual);
    if (ui < 0) return "";
    var diff = r.index - ui;
    if (r.allowance === "fleece") {
      if (diff === 0) return "Your usual tee size " + r.usual + " agrees. It will fit close in this fleece; the size up is the relaxed choice.";
      if (diff === 1) return "Your usual tee size is " + r.usual + ". This fleece is a fitted cut, so " + r.size + " is the size up the site already suggests for a relaxed fit.";
      return "Your usual tee size is " + r.usual + "; by your measurements we would say " + r.size + ". If in doubt, measure a top you own against the table.";
    }
    if (diff === 0) return "Your usual size " + r.usual + " agrees.";
    if (diff === 1) return "Your usual " + r.usual + " would fit closer; " + r.size + " is our pick for the fit you chose.";
    if (diff === -1) return "Your usual " + r.usual + " would fit roomier; " + r.size + " is our pick for the fit you chose.";
    return "Your usual size is " + r.usual + "; by your measurements we would say " + r.size + ". If in doubt, measure a top you own against the table.";
  }
  var S = { GARMENTS: GARMENTS, EASE: EASE, BETWEEN_CM: BETWEEN_CM, CHEST: CHEST, TORSO: TORSO,
            estimateChest: estimateChest, estimateTorso: estimateTorso, recommend: recommend,
            explain: explain, lengthNote: lengthNote, usualNote: usualNote, fitWord: fitWord };
  window.AukSize = S;

  /* ------------------------------------------------------------------ the window ----
     Element ids are the prototype's with an auk-sw- prefix, so $("r-size") here is #r-size there. */
  var KEY = G.key;
  function $(id) { return document.getElementById("auk-sw-" + id); }
  /* num(): the shortest exact text, like build_sizechart.num (f"{v:.10g}"): 28 -> "28", 17.875 -> "17.875".
     cm(): inches x 2.54 to one decimal, rounded on the exact binary value as Python's round() is. */
  function num(v) { return String(Number(v.toPrecision(10))); }
  function cm(v) { return num(Number((v * 2.54).toFixed(1))); }
  function esc(s) { return String(s).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;"); }

  var RM = window.matchMedia ? window.matchMedia("(prefers-reduced-motion: reduce)") : { matches: false };
  var country = "US";
  var activeTab = "chart";
  var rendered = false;

  /* ------------------------------------------------------------------ size chart tab ---- */
  function renderVideo() {
    var box = $("sc-video");
    box.innerHTML = "";
    if (!G.video) return;
    box.innerHTML =
      '<div class="auk-sw-vid">' +
        '<video id="auk-sw-sc-vid" muted loop playsinline preload="metadata" poster="' + esc(G.video.poster) + '" aria-label="Models wearing the tee">' +
          '<source src="' + esc(G.video.src) + '" type="video/mp4">' +
        '</video>' +
        '<button type="button" class="auk-sw-play" id="auk-sw-sc-play" aria-label="Play"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M7 4.5v15l13-7.5z"/></svg></button>' +
      '</div>';
    var v = $("sc-vid"), b = $("sc-play");
    v.muted = true;
    v.addEventListener("play", function () { b.classList.add("playing"); b.setAttribute("aria-label", "Pause"); });
    v.addEventListener("pause", function () { b.classList.remove("playing"); b.setAttribute("aria-label", "Play"); });
    b.addEventListener("click", function () { if (v.paused) { var p = v.play(); if (p && p.catch) p.catch(function () {}); } else { v.pause(); } });
  }
  function chartVisible() { return !root.hidden && activeTab === "chart"; }
  function syncVideo() {
    var v = $("sc-vid");
    if (!v) return;
    if (chartVisible() && !RM.matches) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
    else v.pause();
  }
  if (RM.addEventListener) RM.addEventListener("change", syncVideo);

  function renderTable() {
    var rows = G.rows;
    var h = '<thead><tr><th scope="col">Size</th>' +
      '<th scope="col"><select id="auk-sw-sc-country" aria-label="Country">' +
        ["US", "UK", "EU"].map(function (c) { return '<option value="' + c + '"' + (c === country ? " selected" : "") + '>' + c + '</option>'; }).join("") +
      '</select></th>' +
      rows.map(function (r) { return '<th scope="col">' + esc(r.label) + '</th>'; }).join("") + '</tr></thead><tbody>';
    G.sizes.forEach(function (s, i) {
      var cs = country === "US" ? s : G.country[country][i];
      h += '<tr><th scope="row">' + esc(s) + '</th><td class="auk-sw-cs">' + esc(cs) + '</td>' +
        rows.map(function (r) { var v = r["in"][i]; return '<td><span class="auk-sw-in">' + num(v) + '</span><span class="auk-sw-cm">' + cm(v) + '</span></td>'; }).join("") +
        '</tr>';
    });
    h += "</tbody>";
    $("sc-table").innerHTML = h;
    $("sc-country").addEventListener("change", function () { country = this.value; renderTable(); $("sc-country").focus(); });
  }
  function renderMeasure() {
    var h = '<h3 class="auk-sw-mh">' + esc(G.heading) + '</h3><div class="auk-sw-m-row">' +
      '<div class="auk-sw-m-img"><img src="' + esc(G.drawing) + '" alt="" width="320" height="310"></div><div class="auk-sw-m-txt">';
    G.steps.forEach(function (st) { h += '<p><b>' + esc(st[0]) + '</b>' + esc(st[1]) + '</p>'; });
    h += '<p>' + esc(G.proTip) + '</p><p class="auk-sw-fitline">' + esc(G.fit) + '</p></div></div>';
    $("sc-measure").innerHTML = h;
  }
  function renderChart() {
    if (rendered) return;      /* one garment per page: built on first open, kept after that */
    rendered = true;
    var t = $("win-title");
    if (!t.textContent.replace(/\s+/g, "")) t.textContent = G.label;
    renderVideo();
    var m = $("sc-models");
    m.hidden = !G.video;
    m.textContent = G.video ? G.modelNote : "";
    renderTable();
    renderMeasure();
  }
  Array.prototype.forEach.call(root.querySelectorAll("#auk-sw-sc .auk-sw-unit button"), function (b) {
    b.addEventListener("click", function () {
      $("sc").setAttribute("data-u", b.getAttribute("data-u"));
      Array.prototype.forEach.call(root.querySelectorAll("#auk-sw-sc .auk-sw-unit button"), function (x) { var on = x === b; x.classList.toggle("on", on); x.setAttribute("aria-pressed", on ? "true" : "false"); });
    });
  });

  /* ------------------------------------------------------------------ tabs and window ---- */
  var tabs = Array.prototype.slice.call(root.querySelectorAll('.auk-sw-tabs [role="tab"]'));
  function selectTab(name, focus) {
    activeTab = name;
    tabs.forEach(function (t) {
      var on = t.getAttribute("data-tab") === name;
      t.setAttribute("aria-selected", on ? "true" : "false");
      t.tabIndex = on ? 0 : -1;
      document.getElementById(t.getAttribute("aria-controls")).hidden = !on;
      if (on && focus) t.focus();
    });
    $("win-body").scrollTop = 0;
    syncVideo();
  }
  tabs.forEach(function (t) {
    t.addEventListener("click", function () { selectTab(t.getAttribute("data-tab"), false); });
    t.addEventListener("keydown", function (ev) {
      var i = tabs.indexOf(t), n = null;
      if (ev.key === "ArrowRight" || ev.key === "ArrowDown") n = (i + 1) % tabs.length;
      else if (ev.key === "ArrowLeft" || ev.key === "ArrowUp") n = (i - 1 + tabs.length) % tabs.length;
      else if (ev.key === "Home") n = 0;
      else if (ev.key === "End") n = tabs.length - 1;
      if (n == null) return;
      ev.preventDefault();
      selectTab(tabs[n].getAttribute("data-tab"), true);
    });
  });

  /* Background scroll: locked while the window is open, put back where it was on close. */
  var scrollY = 0;
  function lockScroll() {
    scrollY = window.pageYOffset || document.documentElement.scrollTop || 0;
    document.documentElement.classList.add("auk-sw-lock");
    document.body.classList.add("auk-sw-lock");
  }
  function unlockScroll() {
    document.documentElement.classList.remove("auk-sw-lock");
    document.body.classList.remove("auk-sw-lock");
    if ((window.pageYOffset || 0) !== scrollY) window.scrollTo(0, scrollY);
  }

  var lastFocus = null;
  function openWin(tab, opener) {
    lastFocus = opener || document.activeElement;
    root.hidden = false;
    lockScroll();
    renderChart();
    selectTab(tab, true);
  }
  function closeWin() {
    if (root.hidden) return;
    var v = $("sc-vid"); if (v) v.pause();
    root.hidden = true;
    unlockScroll();
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  /* The two entry links render inside the buy form; one delegated listener finds them wherever they sit. */
  document.addEventListener("click", function (ev) {
    var b = ev.target && ev.target.closest ? ev.target.closest("[data-auk-sw-open]") : null;
    if (!b) return;
    ev.preventDefault();
    openWin(b.getAttribute("data-auk-sw-open") === "calc" ? "calc" : "chart", b);
  });
  $("close").addEventListener("click", closeWin);
  root.addEventListener("click", function (ev) { if (ev.target === root) closeWin(); });
  document.addEventListener("keydown", function (ev) {
    if (root.hidden) return;
    if (ev.key === "Escape") { ev.preventDefault(); closeWin(); return; }
    if (ev.key === "Tab") {   /* keep focus inside the window */
      var f = Array.prototype.filter.call(root.querySelectorAll('button, [href], input, select, textarea, summary, [tabindex]:not([tabindex="-1"])'),
        function (el) { return !el.disabled && el.offsetParent !== null; });
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (ev.shiftKey && document.activeElement === first) { ev.preventDefault(); last.focus(); }
      else if (!ev.shiftKey && document.activeElement === last) { ev.preventDefault(); first.focus(); }
    }
  });

  /* ------------------------------------------------------------------ calculator ---- */
  var units = "metric", sex = null;
  try { units = localStorage.getItem("auk-size-units") || "metric"; } catch (e) {}
  function unitButtons() { return root.querySelectorAll("#auk-sw-form .auk-sw-unit button"); }
  function setUnits(u) {
    units = u;
    try { localStorage.setItem("auk-size-units", u); } catch (e) {}
    Array.prototype.forEach.call(unitButtons(), function (b) { var on = b.getAttribute("data-u") === u; b.classList.toggle("on", on); b.setAttribute("aria-pressed", on ? "true" : "false"); });
    $("h-metric").hidden = u !== "metric"; $("h-imperial").hidden = u !== "imperial";
    $("w_kg").hidden = u !== "metric"; $("w_lb").hidden = u !== "imperial";
    $("c_cm").hidden = u !== "metric"; $("c_in").hidden = u !== "imperial";
  }
  Array.prototype.forEach.call(unitButtons(), function (b) { b.addEventListener("click", function () { setUnits(b.getAttribute("data-u")); }); });
  function seg(id, cb) {
    var btns = $(id).querySelectorAll("button");
    Array.prototype.forEach.call(btns, function (b) {
      b.addEventListener("click", function () {
        Array.prototype.forEach.call(btns, function (x) { x.classList.toggle("on", x === b); });
        cb(b.getAttribute("data-v"));
      });
    });
  }
  seg("sex", function (v) { sex = v; });
  var fitPref = "regular";
  seg("fit", function (v) { fitPref = v; if ($("res").classList.contains("show")) run(); });
  setUnits(units);

  function numv(id) { var v = parseFloat($(id).value); return isNaN(v) ? null : v; }
  function readInput() {
    var cmv, kg, chest = null;
    if (units === "metric") { cmv = numv("h_cm"); kg = numv("w_kg"); chest = numv("c_cm"); }
    else {
      var ft = numv("h_ft"), inch = numv("h_in") || 0; cmv = ft == null ? null : (ft * 12 + inch) * 2.54;
      var lb = numv("w_lb"); kg = lb == null ? null : lb * 0.45359237;
      var ci = numv("c_in"); chest = ci == null ? null : ci * 2.54;
    }
    return { cm: cmv, kg: kg, chestCm: chest, age: numv("age"), usual: $("usual").value || null };
  }
  function validate(i) {
    if (i.cm == null || i.kg == null) return "Enter your height and weight.";
    if (i.cm < 120 || i.cm > 230) return "Please check your height.";
    if (i.kg < 30 || i.kg > 250) return "Please check your weight.";
    if (!sex && !(i.chestCm > 0)) return "Choose a body type, or enter your chest measurement.";
    return "";
  }
  function fmt(v, u) { return u === "metric" ? cm(v) + " cm" : num(v) + " in"; }
  function run() {
    var i = readInput();
    var e = validate(i);
    $("err").textContent = e;
    if (e) { $("res").classList.remove("show"); return; }
    var r = S.recommend({ garment: KEY, kg: i.kg, cm: i.cm, sex: sex || "x", age: i.age, fit: fitPref, chestCm: i.chestCm, usual: i.usual });
    // Stephen 2026-10-18: the result names the product ("Rally Driver T-Shirt in this size:"), not the garment label.
    var wt = $("win-title").textContent.replace(/\s+/g, " ").trim();
    $("r-garment").textContent = (wt || r.label) + " in this size:";
    $("r-size").innerHTML = r.size + (r.chestBasis === "measured" ? "<small>Based on the chest you entered</small>" : "<small>Estimated from your height and weight" + (i.age ? " and age" : "") + "</small>");
    $("r-why").textContent = S.explain(r);
    var t = S.EASE[r.allowance];
    var pos = (r.room - (t.closer - 6)) / ((t.roomier + 6) - (t.closer - 6));
    $("r-pin").style.left = (Math.max(0, Math.min(1, pos)) * 100) + "%";
    var g = S.GARMENTS[r.garment];
    var alt = "";
    [r.index - 1, r.index + 1].forEach(function (k) {
      if (k < 0 || k >= g.sizes.length) return;
      var row = r.rows[k];
      alt += "<div><span class='auk-sw-small'>" + (k < r.index ? "Size down" : "Size up") + "</span><b>" + row.size + "</b>" + S.fitWord(row.room, r.allowance) + ", " + Math.round(row.room) + " cm of room</div>";
    });
    $("r-alt").innerHTML = alt;
    var head = "<tr><th></th>" + g.sizes.map(function (s) { return "<th>" + s + "</th>"; }).join("") + "</tr>";
    function line(label, arr) {
      if (!arr) return "";
      return "<tr><td>" + label + "</td>" + arr.map(function (v, k) { return "<td" + (k === r.index ? " class='pick'" : "") + ">" + fmt(v, units) + "</td>"; }).join("") + "</tr>";
    }
    $("r-table").innerHTML = head + line("Length", g.length) + line("Width, laid flat", g.width) + line("Sleeve", g.sleeve);
    Array.prototype.forEach.call($("r-table").querySelectorAll("td.pick"), function (td) { td.parentNode.classList.add("has-pick"); });
    $("r-note").textContent = S.lengthNote(r) + " Width doubles as the chest measurement.";
    $("r-units").textContent = units === "metric" ? "All figures in centimetres." : "All figures in inches.";
    $("r-usual").textContent = S.usualNote(r);
    $("res").classList.add("show");
    $("res").scrollIntoView({ behavior: "smooth", block: "start" });
  }
  $("go").addEventListener("click", run);
  Array.prototype.forEach.call(root.querySelectorAll("#auk-sw-form input"), function (el) { el.addEventListener("keydown", function (ev) { if (ev.key === "Enter") run(); }); });
})();
